import {ASSETS_ROOT} from './../../../../../@polygonjs/polygonjs/src/core/loader/AssetsUtils';
import type {MaterialsNetworkSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/MaterialsNetwork';
import type {CopNetworkObjNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/obj/CopNetwork';
import type {EventsNetworkSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/EventsNetwork';
import type {PerspectiveCameraObjNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/obj/PerspectiveCamera';
import type {AnimationsNetworkSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/AnimationsNetwork';
import type {GeoObjNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/obj/Geo';
import type {RootManagerNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/manager/Root';
import type {ExampleData, DataCallbackOptions} from '../../Common';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();

	// 	var nodesByRequestedName_2 = {}
	// var geo1 = parentNode.node('geo1')
	// var grid = parentNode.node('grid')
	// var hemisphereLight1 = parentNode.node('hemisphereLight1')
	// var perspectiveCamera1 = parentNode.node('perspectiveCamera1')
	// var COP = parentNode.node('COP')
	function create_geo1(parentNode: RootManagerNode) {
		var geo1 = parentNode.createNode('geo');
		geo1.setName('geo1');
		function create_ANIM(geo1: GeoObjNode) {
			var ANIM = geo1.createNode('animationsNetwork');
			ANIM.setName('ANIM');
			function create_CONTROLS(ANIM: AnimationsNetworkSopNode) {
				var CONTROLS = ANIM.createNode('play');
				CONTROLS.setName('CONTROLS');
				CONTROLS.uiData.setComment('Use this node to start/stop the animation.');
				CONTROLS.uiData.setPosition(-150, 700);
				CONTROLS.params.postCreateSpareParams();
				CONTROLS.params.runOnSceneLoadHooks();
				return CONTROLS;
			}
			function create_PLAY(ANIM: AnimationsNetworkSopNode) {
				var PLAY = ANIM.createNode('null');
				PLAY.setName('PLAY');
				PLAY.uiData.setPosition(0, 600);
				PLAY.params.postCreateSpareParams();
				PLAY.params.runOnSceneLoadHooks();
				return PLAY;
			}
			function create_RESET(ANIM: AnimationsNetworkSopNode) {
				var RESET = ANIM.createNode('null');
				RESET.setName('RESET');
				RESET.uiData.setPosition(-300, 600);
				RESET.params.postCreateSpareParams();
				RESET.params.runOnSceneLoadHooks();
				return RESET;
			}
			function create_duration1(ANIM: AnimationsNetworkSopNode) {
				var duration1 = ANIM.createNode('duration');
				duration1.setName('duration1');
				duration1.uiData.setPosition(0, -250);
				duration1.params.postCreateSpareParams();
				duration1.params.runOnSceneLoadHooks();
				return duration1;
			}
			function create_easing1(ANIM: AnimationsNetworkSopNode) {
				var easing1 = ANIM.createNode('easing');
				easing1.setName('easing1');
				easing1.uiData.setPosition(-100, -100);
				easing1.params.postCreateSpareParams();
				easing1.params.runOnSceneLoadHooks();
				return easing1;
			}
			function create_easing2(ANIM: AnimationsNetworkSopNode) {
				var easing2 = ANIM.createNode('easing');
				easing2.setName('easing2');
				easing2.uiData.setPosition(50, -100);
				easing2.p.name.set(1);
				easing2.p.inOut.set(2);
				easing2.params.postCreateSpareParams();
				easing2.params.runOnSceneLoadHooks();
				return easing2;
			}
			function create_easing3(ANIM: AnimationsNetworkSopNode) {
				var easing3 = ANIM.createNode('easing');
				easing3.setName('easing3');
				easing3.uiData.setPosition(250, -100);
				easing3.p.name.set(6);
				easing3.p.inOut.set(2);
				easing3.params.postCreateSpareParams();
				easing3.params.runOnSceneLoadHooks();
				return easing3;
			}
			function create_propertyName1(ANIM: AnimationsNetworkSopNode) {
				var propertyName1 = ANIM.createNode('propertyName');
				propertyName1.setName('propertyName1');
				propertyName1.uiData.setPosition(0, 400);
				propertyName1.params.postCreateSpareParams();
				propertyName1.params.runOnSceneLoadHooks();
				return propertyName1;
			}
			function create_propertyValue1(ANIM: AnimationsNetworkSopNode) {
				var propertyValue1 = ANIM.createNode('propertyValue');
				propertyValue1.setName('propertyValue1');
				propertyValue1.uiData.setPosition(0, 500);
				propertyValue1.p.value3.y.set(1);
				propertyValue1.params.postCreateSpareParams();
				propertyValue1.params.runOnSceneLoadHooks();
				return propertyValue1;
			}
			function create_propertyValue2(ANIM: AnimationsNetworkSopNode) {
				var propertyValue2 = ANIM.createNode('propertyValue');
				propertyValue2.setName('propertyValue2');
				propertyValue2.uiData.setPosition(-300, 500);
				propertyValue2.params.postCreateSpareParams();
				propertyValue2.params.runOnSceneLoadHooks();
				return propertyValue2;
			}
			function create_switch1(ANIM: AnimationsNetworkSopNode) {
				var switch1 = ANIM.createNode('switch');
				switch1.setName('switch1');
				switch1.uiData.setComment(
					'With this switch node, you can select which easing node would be used on the animation. '
				);
				switch1.uiData.setPosition(0, 100);
				switch1.p.input.set(2);
				switch1.params.postCreateSpareParams();
				switch1.params.runOnSceneLoadHooks();
				return switch1;
			}
			function create_target1(ANIM: AnimationsNetworkSopNode) {
				var target1 = ANIM.createNode('target');
				target1.setName('target1');
				target1.uiData.setPosition(0, 300);
				target1.p.objectMask.set('*/animTarget');
				target1.params.postCreateSpareParams();
				target1.params.runOnSceneLoadHooks();
				return target1;
			}
			var CONTROLS = create_CONTROLS(ANIM);
			var PLAY = create_PLAY(ANIM);
			var RESET = create_RESET(ANIM);
			var duration1 = create_duration1(ANIM);
			var easing1 = create_easing1(ANIM);
			var easing2 = create_easing2(ANIM);
			var easing3 = create_easing3(ANIM);
			var propertyName1 = create_propertyName1(ANIM);
			var propertyValue1 = create_propertyValue1(ANIM);
			var propertyValue2 = create_propertyValue2(ANIM);
			var switch1 = create_switch1(ANIM);
			var target1 = create_target1(ANIM);
			CONTROLS.setInput(0, RESET);
			CONTROLS.setInput(1, PLAY);
			PLAY.setInput(0, propertyValue1);
			RESET.setInput(0, propertyValue2);
			easing1.setInput(0, duration1);
			easing2.setInput(0, duration1);
			easing3.setInput(0, duration1);
			propertyName1.setInput(0, target1);
			propertyValue1.setInput(0, propertyName1);
			propertyValue2.setInput(0, propertyName1);
			switch1.setInput(0, easing1);
			switch1.setInput(1, easing2);
			switch1.setInput(2, easing3);
			target1.setInput(0, switch1);
			ANIM.childrenController!.selection.add([CONTROLS]);
			ANIM.uiData.setPosition(-250, 350);
			ANIM.params.postCreateSpareParams();
			ANIM.params.runOnSceneLoadHooks();
			return {ANIM, CONTROLS};
		}
		function create_MAT(geo1: GeoObjNode) {
			var MAT = geo1.createNode('materialsNetwork');
			MAT.setName('MAT');
			function create_meshStandard1(MAT: MaterialsNetworkSopNode) {
				var meshStandard1 = MAT.createNode('meshStandard');
				meshStandard1.setName('meshStandard1');
				meshStandard1.uiData.setPosition(0, 100);
				meshStandard1.p.useMap.set(true);
				meshStandard1.p.map.set('../../../COP/imageUv');
				meshStandard1.p.useEnvMap.set(true);
				meshStandard1.p.envMap.set('../../../COP/envMap');
				meshStandard1.p.metalness.set(1);
				meshStandard1.p.roughness.set(0.07);
				meshStandard1.params.postCreateSpareParams();
				meshStandard1.params.runOnSceneLoadHooks();
				return meshStandard1;
			}
			create_meshStandard1(MAT);
			MAT.uiData.setPosition(-250, 150);
			MAT.params.postCreateSpareParams();
			MAT.params.runOnSceneLoadHooks();
			return MAT;
		}
		function create_material1(geo1: GeoObjNode) {
			var material1 = geo1.createNode('material');
			material1.setName('material1');
			material1.uiData.setPosition(0, 150);
			material1.p.material.set('../MAT/meshStandard1');
			material1.params.postCreateSpareParams();
			material1.params.runOnSceneLoadHooks();
			return material1;
		}
		function create_objectProperties1(geo1: GeoObjNode) {
			var objectProperties1 = geo1.createNode('objectProperties');
			objectProperties1.setName('objectProperties1');
			objectProperties1.uiData.setPosition(0, 300);
			objectProperties1.flags.display.set(true);
			objectProperties1.p.tname.set(true);
			objectProperties1.p.name.set('animTarget');
			objectProperties1.params.postCreateSpareParams();
			objectProperties1.params.runOnSceneLoadHooks();
			return objectProperties1;
		}
		function create_sphere1(geo1: GeoObjNode) {
			var sphere1 = geo1.createNode('sphere');
			sphere1.setName('sphere1');
			sphere1.uiData.setPosition(0, 50);
			sphere1.params.postCreateSpareParams();
			sphere1.params.runOnSceneLoadHooks();
			return sphere1;
		}
		var ANIM = create_ANIM(geo1);
		create_MAT(geo1);
		var material1 = create_material1(geo1);
		var objectProperties1 = create_objectProperties1(geo1);
		var sphere1 = create_sphere1(geo1);
		material1.setInput(0, sphere1);
		objectProperties1.setInput(0, material1);
		geo1.uiData.setPosition(-50, -150);
		geo1.flags.display.set(true);
		geo1.params.postCreateSpareParams();
		geo1.params.runOnSceneLoadHooks();
		return {geo1, ...ANIM};
	}
	function create_grid(parentNode: RootManagerNode) {
		var grid = parentNode.createNode('geo');
		grid.setName('grid');
		function create_planeHelper1(grid: GeoObjNode) {
			var planeHelper1 = grid.createNode('planeHelper');
			planeHelper1.setName('planeHelper1');
			planeHelper1.uiData.setPosition(0, 0);
			planeHelper1.flags.display.set(true);
			planeHelper1.params.postCreateSpareParams();
			planeHelper1.params.runOnSceneLoadHooks();
			return planeHelper1;
		}
		create_planeHelper1(grid);
		grid.uiData.setPosition(-50, -250);
		grid.flags.display.set(true);
		grid.params.postCreateSpareParams();
		grid.params.runOnSceneLoadHooks();
		return grid;
	}
	function create_hemisphereLight1(parentNode: RootManagerNode) {
		var hemisphereLight1 = parentNode.createNode('hemisphereLight');
		hemisphereLight1.setName('hemisphereLight1');
		hemisphereLight1.uiData.setPosition(150, 100);
		hemisphereLight1.flags.display.set(true);
		hemisphereLight1.params.postCreateSpareParams();
		hemisphereLight1.params.runOnSceneLoadHooks();
		return hemisphereLight1;
	}
	function create_perspectiveCamera1(parentNode: RootManagerNode) {
		var perspectiveCamera1 = parentNode.createNode('perspectiveCamera');
		perspectiveCamera1.setName('perspectiveCamera1');
		function create_events1(perspectiveCamera1: PerspectiveCameraObjNode) {
			var events1 = perspectiveCamera1.createNode('eventsNetwork');
			events1.setName('events1');
			function create_cameraOrbitControls1(events1: EventsNetworkSopNode) {
				var cameraOrbitControls1 = events1.createNode('cameraOrbitControls');
				cameraOrbitControls1.setName('cameraOrbitControls1');
				cameraOrbitControls1.uiData.setPosition(150, 50);
				cameraOrbitControls1.p.target.x.set(0.2140135607673551);
				cameraOrbitControls1.p.target.y.set(0.08486305110524985);
				cameraOrbitControls1.p.target.z.set(-0.31163000976043653);
				cameraOrbitControls1.params.postCreateSpareParams();
				cameraOrbitControls1.params.runOnSceneLoadHooks();
				return cameraOrbitControls1;
			}
			create_cameraOrbitControls1(events1);
			events1.uiData.setPosition(-200, 50);
			events1.params.postCreateSpareParams();
			events1.params.runOnSceneLoadHooks();
			return events1;
		}
		create_events1(perspectiveCamera1);
		perspectiveCamera1.uiData.setPosition(-200, 100);
		perspectiveCamera1.flags.display.set(true);
		perspectiveCamera1.p.t.x.set(3.0161526633531355);
		perspectiveCamera1.p.t.y.set(1.1787657307191874);
		perspectiveCamera1.p.t.z.set(2.814738208647524);
		perspectiveCamera1.p.r.x.set(-22.723127930556515);
		perspectiveCamera1.p.r.y.set(44.66532130223666);
		perspectiveCamera1.p.r.z.set(16.403892417511617);
		perspectiveCamera1.p.controls.set('./events1/cameraOrbitControls1');
		perspectiveCamera1.params.postCreateSpareParams();
		perspectiveCamera1.params.runOnSceneLoadHooks();
		return perspectiveCamera1;
	}
	function create_COP(parentNode: RootManagerNode) {
		var COP = parentNode.createNode('copNetwork');
		COP.setName('COP');
		function create_envMap(COP: CopNetworkObjNode) {
			var envMap = COP.createNode('envMap');
			envMap.setName('envMap');
			envMap.uiData.setPosition(50, 200);
			envMap.params.postCreateSpareParams();
			envMap.params.runOnSceneLoadHooks();
			return envMap;
		}
		function create_imageEnv(COP: CopNetworkObjNode) {
			var imageEnv = COP.createNode('imageEXR');
			imageEnv.setName('imageEnv');
			imageEnv.uiData.setPosition(50, 100);
			imageEnv.p.url.set(`${ASSETS_ROOT}/textures/piz_compressed.exr`);
			imageEnv.params.postCreateSpareParams();
			imageEnv.params.runOnSceneLoadHooks();
			return imageEnv;
		}
		function create_imageUv(COP: CopNetworkObjNode) {
			var imageUv = COP.createNode('image');
			imageUv.setName('imageUv');
			imageUv.uiData.setPosition(-100, 100);
			imageUv.p.url.set(`${ASSETS_ROOT}/textures/uv.jpg`);
			imageUv.p.tflipY.set(true);
			imageUv.params.postCreateSpareParams();
			imageUv.params.runOnSceneLoadHooks();
			return imageUv;
		}
		var envMap = create_envMap(COP);
		var imageEnv = create_imageEnv(COP);
		create_imageUv(COP);
		envMap.setInput(0, imageEnv);
		COP.uiData.setPosition(-200, 200);
		COP.params.postCreateSpareParams();
		COP.params.runOnSceneLoadHooks();
		return COP;
	}
	const {CONTROLS} = create_geo1(root);
	create_grid(root);
	create_hemisphereLight1(root);
	var perspectiveCamera1 = create_perspectiveCamera1(root);
	create_COP(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [CONTROLS],
	};
}

// export const animEasing = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/anim/easing`,
// 		createData,
// 		relatedNodes: [EasingAnimNode],
// 		categories: [ExampleCategory.ANIMATION],
// 	}),
// 	// new Example({name: `${ExamplePrefix.BY_CATEGORY}/animation/Easing`, createData}),
// ];
